import { persistDashboardConnector } from 'apiConnector/dashboard/persist';
import * as apiErrorHelper from 'epic/apiErrorEpicHelper';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { showNotificationThunk } from 'state/notifications/notification.thunk';
import { dashboardPersisted, dashboardPersistenceFailed } from 'state/quotes/dashboard/dashboard.actions';
import type { EpicWithThunk } from 'state/state.common';

export function saveActiveQuotes(): EpicWithThunk {
  return (actions$, _$state, { httpClient }) =>
    actions$.pipe(
      ofType('DASHBOARD_PERSISTENCE_REQUESTED'),
      mergeMap(action => {
        return persistDashboardConnector(httpClient)
          .persist(action.request)
          .pipe(
            map(dashboardPersisted),
            catchError(err =>
              of(
                dashboardPersistenceFailed(apiErrorHelper.toApiErrorMessage(err)),
                showNotificationThunk({
                  level: 'warning',
                  title: { id: 'dashboard.errors.title' },
                  content: [{ id: 'dashboard.errors.savingFailed' }],
                }),
              ),
            ),
          );
      }),
    );
}
